import { Link } from 'react-router-dom';

/** Branded in-app 404 for unknown routes (rendered inside the app shell). */
export function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center py-24 text-center">
      <p className="text-6xl font-extrabold tracking-tight text-emerald-500">404</p>
      <h1 className="mt-4 text-2xl font-bold tracking-tight">Page not found</h1>
      <p className="mt-2 max-w-sm text-sm text-neutral-500">
        That page doesn’t exist or has moved. Let’s get you back to your book.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition hover:bg-emerald-700"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
